import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Link } from '@app/components/stateless/typo/link'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'
import { FaqSection } from '@app/components/marketing/faq-section'
import { twitterBuilder } from '@app/lib/twitter-builder'
import { companyName } from '@app/configs'
import { DOMAIN_NAME, FILTERED_MARKETING } from '@app/configs/app-config'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/faq',
    }),
  }
}

function Faq() {
  const { t, lang } = useTranslation('faq')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <div>
          <Header>{t('header')}</Header>
          <Paragraph>{t('header-details')}</Paragraph>
        </div>

        <FaqSection t={t} lang={lang} headers={'h2'} />

        {FILTERED_MARKETING ? null : (
          <>
            <Header3 header4>{t('spread')}</Header3>
            <Trans
              i18nKey='faq:spread-details'
              values={{ companyName: companyName }}
              components={[
                <Paragraph key={'spread-d-1'} />,
                <Link
                  href={DOMAIN_NAME}
                  className={blueLink}
                  key={'spead-d-2'}
                />,
                <Link
                  target='_blank'
                  className={blueLink}
                  href={`https://twitter.com/${twitterBuilder(lang)}`}
                  key={'spread-d-3'}
                />,
                <b key={'spread-d-4'} />,
              ]}
            />
          </>
        )}
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Faq },
  {
    translation: 'faq',
  }
)
